import { Skeleton } from "antd";
import { Fragment, useRef, useState } from "react";
import { getContentType, handleError } from "../../../../utils/common-utils";
import { CAM_IMG_PATH } from "../../../../utils/constants";
import { validateFileSize } from "../../../../utils/validation";
import FileView from "../../../FileView";
import { uploadFile, uploadFileOnURL } from "../api-handler";
import PlaceholderImage from "../PlaceholderImage";

const SingleImageView = (props) => {
  const [loading, setLoading] = useState(false);

  const {
    fileValue,
    maxSizeContent,
    dimensions,
    setMessage,
    imageViewClass,
    onFileSelectSuccess,
    placeholderImgClass,
    content,
    acceptedFiles,
    PlaceholderView,
    onRemove,
  } = props;

  let fileInput = useRef();

  const uploadSingleFile = (file) => {
    setLoading(true);
    uploadFile(file)
      .then((response) => {
        const { data } = response;
        const { uploadUrl, accessUrl } = data;

        uploadFileOnURL(file, uploadUrl).then(() => {
          onFileSelectSuccess(accessUrl);
          setMessage("");
          setLoading(false);
        });
      })
      .catch((error) => {
        setLoading(false);
        const errorMessage = handleError(error);
        setMessage(errorMessage);
      });
  };

  const onFileChange = (e) => {
    const file = e.target.files[0];
    const { dimensionHeight, dimensionWidth } = dimensions;

    if (!file) return;

    const { error } = validateFileSize(file);

    if (error) setMessage(error);
    else {
      const { type } = file;
      const typeExt = type.split("/")[1];

      const contentType = getContentType(typeExt);

      if (contentType) {
        if (
          contentType.includes("image") &&
          dimensionHeight &&
          dimensionWidth
        ) {
          const img = new Image();
          let objectUrl = window.URL.createObjectURL(file);
          img.src = objectUrl;

          img.onload = () => {
            const { height, width } = img;
            if (height !== +dimensionHeight || width !== +dimensionWidth) {
              setMessage(
                `File dimensions must be ${dimensionWidth} X ${dimensionHeight}`
              );
            } else {
              uploadSingleFile(file);
            }
          };
        } else {
          uploadSingleFile(file);
        }
      } else {
        setMessage(`File type ${typeExt} is not allowed.`);
      }
    }
  };

  const fileViewProps = {
    ...(onRemove && { onRemove }),
  };

  return (
    <Fragment>
      <input
        type="file"
        id="file"
        onChange={onFileChange}
        hidden={true}
        multiple={false}
        accept={acceptedFiles}
        onClick={(event) => {
          event.target.value = null;
        }}
        ref={(refParam) => (fileInput = refParam)}
      />

      {loading ? (
        <Skeleton.Image
          active={true}
          className={`${placeholderImgClass} full-width input-border-radius placeholder-skeleton-img`}
        />
      ) : (
        <Fragment>
          {fileValue ? (
            <div className={`uploaded-files-container ${imageViewClass || ""}`}>
              <FileView fileURL={fileValue} {...fileViewProps} />

              <div className="change-file-btn">
                <div
                  onClick={() => {
                    fileInput.click();
                  }}
                  className="btn"
                >
                  <img src={CAM_IMG_PATH} alt={CAM_IMG_PATH} />
                </div>
              </div>
            </div>
          ) : null}

          {!fileValue && PlaceholderView && (
            <PlaceholderView onClick={() => fileInput.click()} />
          )}

          {!fileValue && !PlaceholderView && (
            <PlaceholderImage
              className={placeholderImgClass}
              content={content}
              maxSizeContent={maxSizeContent}
              onChooseFile={() => {
                fileInput.click();
              }}
            />
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

export default SingleImageView;
